import { SlidersHorizontalIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle } from '@/components/ui/sheet';

/**
 * Desktop: the controls inline with the order hint. Phone: one "Filters (n)"
 * button opening a bottom sheet; the screen keeps a draft and commits on
 * Apply so the list behind the sheet does not reflow while it is open.
 */
export function FilterBar({
  desktop, sheet, activeCount, hint, sheetOpen, onSheetOpenChange, onApply, onClear,
}: {
  desktop: ReactNode;
  sheet: ReactNode;
  activeCount: number;
  hint: ReactNode;
  sheetOpen: boolean;
  onSheetOpenChange: (open: boolean) => void;
  onApply: () => void;
  onClear: () => void;
}) {
  return (
    <div data-slot="filter-bar" className="flex items-center justify-between gap-3">
      <div className="hidden min-w-0 flex-wrap items-center gap-2 md:flex">{desktop}</div>
      <Sheet open={sheetOpen} onOpenChange={onSheetOpenChange}>
        <Button variant="outline" className="h-11 md:hidden" onClick={() => onSheetOpenChange(true)}>
          <SlidersHorizontalIcon aria-hidden="true" data-icon="inline-start" />
          Filters ({activeCount})
        </Button>
        <SheetContent side="bottom" showCloseButton={false} className="max-h-[85svh] rounded-t-[20px] shadow-beam-3">
          <div aria-hidden="true" className="mx-auto mt-2 h-1 w-10 rounded-full bg-beam-line-strong" />
          <SheetHeader className="flex-row items-center justify-between pb-0">
            <SheetTitle className="text-base">Filters</SheetTitle>
            <SheetDescription className="sr-only">Filter the queue</SheetDescription>
            <Button variant="link" className="h-11 px-2" onClick={onClear}>Clear</Button>
          </SheetHeader>
          <div className="flex-1 overflow-y-auto px-4">{sheet}</div>
          <SheetFooter className="pt-2">
            <Button className="h-11 w-full" onClick={onApply}>Apply</Button>
          </SheetFooter>
        </SheetContent>
      </Sheet>
      <p className="shrink-0 text-xs text-beam-text-muted">{hint}</p>
    </div>
  );
}
